import { render, staticRenderFns } from "./productDirection.vue?vue&type=template&id=5695274a&scoped=true&"
import script from "./productDirection.vue?vue&type=script&lang=js&"
export * from "./productDirection.vue?vue&type=script&lang=js&"
import style0 from "./productDirection.vue?vue&type=style&index=0&id=5695274a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5695274a",
  null
  
)

export default component.exports